import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthComponent } from "./auth.component";
import { routing } from "./auth.routing";
import { AuthService } from "./auth.service";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ReactiveFormsModule } from "@angular/forms";
import { EmailComponent } from './email/email.component';

@NgModule({
  imports: [CommonModule, routing, ReactiveFormsModule],
  declarations: [AuthComponent, ForgotPasswordComponent, EmailComponent],
  providers: [AuthService]
})
export class AuthModule {}
